export default "__VITE_ASSET__e6b08e6a__"